<script>
import HomeCardCarousel from "@/components/Home/New/HomeCardCarousel.vue";
import HomeFilters from "@/components/Home/New/HomeFilters.vue";

export default {
  name: "ManagerSupportContent",
  components: { HomeFilters, HomeCardCarousel }
};
</script>

<template>
  <div id="ManagerSupportContent" class="pt-5 carousel-container">
    <HomeFilters
      title="Filters"
      :hardcoded-tags="[
        'Manager guidance',
        'Life',
        'Mind',
        'Body',
        'Working well'
      ]"
      starting-tag="Manager guidance"
    />
    <HomeCardCarousel
      title="Videos"
      class="car"
      type="standaloneArticles"
      additionalTag="Videos"
      :mute="true"
      starting-tag="Manager guidance"
    >
    </HomeCardCarousel>
    <HomeCardCarousel
      title="Articles"
      class="car"
      cardType="article"
      type="standaloneArticles"
      additionalTag="Articles"
      :mute="true"
      starting-tag="Manager guidance"
    >
    </HomeCardCarousel>
  </div>
</template>

<style lang="less">
#ManagerSupportContent {
  .filterSearchBar {
    all: unset;
    width: 98%;
    height: 40px;
    background-color: rgba(255, 255, 255, 1);
    border: 1px solid rgba(211, 211, 211, 1);
    border-radius: 6px;
    padding: 5px 20px;
    font-size: 1.5rem;
    box-sizing: border-box;
    font-family: FilsonProBold, Arial, Helvetica, sans-serif !important;
  }
}
</style>
